import React from 'react';

/**
 * Footer shown on public auth-related pages (Login, Signup, Forgot Password).
 * Links open in a new tab per Meta App Review / Razorpay verification
 * requirements, so reviewers can inspect legal pages without losing their
 * place in the auth flow.
 */
export function AuthFooter() {
  const link = (href, label, testid) => (
    <a
      key={testid}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className="hover:text-fab-primary font-semibold"
    >{label}</a>
  );
  return (
    <div className="mt-6 text-center text-[12px] text-fab-text-muted" data-testid="auth-footer">
      <div className="flex flex-wrap justify-center gap-x-5 gap-y-1">
        {link('/privacy-policy', 'Privacy Policy', 'footer-privacy-link')}
        {link('/terms-of-service', 'Terms of Service', 'footer-tos-link')}
        {link('/data-deletion', 'Data Deletion', 'footer-data-deletion-link')}
        {link('/contact-us', 'Contact Us', 'footer-contact-link')}
      </div>
      <div className="mt-1.5">© {new Date().getFullYear()} FABTEXS – India’s Wholesale Fabric Hub</div>
    </div>
  );
}

export default AuthFooter;
